export function fill<T extends Record<string, unknown>>(input: unknown, provider: T): T {
    const object = input as any;
    if (!provider) {
        return object;
    }
    for(const key of Object.keys(provider)) {
        if (object[key] === undefined) {
            object[key] = provider[key];
        }
    }
    return object
}
